/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GAPriceDto } from '../models/GAPriceDto';
import type { GAPriceSearchData } from '../models/GAPriceSearchData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GaPriceService {
    /**
     * Calculate a single GA price
     * Proxies the request to the GA Calc Lambda and passes the response body through.
     * HTTP is always 200; the logical outcome is carried in the response body `ResponseStatus`
     * field ("200" success, "400" validation failure, "404" discount not found, "500" internal error).
     * Requires the `tps.read` role; returns 403 otherwise.
     *
     * @param requestBody
     * @returns GAPriceDto GA price calculation result. HTTP 200 is always returned for calc requests.
     * Inspect `ResponseStatus` in the body for the logical outcome.
     *
     * @throws ApiError
     */
    public static createCalculation(
        requestBody: GAPriceSearchData,
    ): CancelablePromise<GAPriceDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/calculations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Missing or invalid bearer token.`,
                403: `Authenticated but not authorized for this operation.`,
                503: `GA Calculator kill switch is active; calculation temporarily disabled.`,
            },
        });
    }
    /**
     * Calculate GA prices for multiple items
     * Proxies the bulk request to the GA Calc Lambda and passes the response array through.
     * The request body is a bare JSON array of GAPriceSearchData objects (not wrapped in an object).
     * The response is a bare JSON array of GAPriceDto objects, one per input item, order preserved.
     * HTTP is always 200; each item's logical outcome is in its own `ResponseStatus` field.
     * Requires the `tps.read` role; returns 403 otherwise.
     *
     * @param requestBody
     * @returns GAPriceDto Array of GA price calculation results, one per input item, order preserved.
     * Inspect each item's `ResponseStatus` for its logical outcome.
     *
     * @throws ApiError
     */
    public static createCalculationBatch(
        requestBody: Array<GAPriceSearchData>,
    ): CancelablePromise<Array<GAPriceDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/calculations/batch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Missing or invalid bearer token.`,
                403: `Authenticated but not authorized for this operation.`,
                503: `GA Calculator kill switch is active; calculation temporarily disabled.`,
            },
        });
    }
}
